import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { LookLayer, startLook } from './look';
import './styles/app.css';
import './styles/looks/bold.css';
import './styles/looks/playful.css';
import './styles/looks/theatre.css';

// The look (Bold, Clinical, Playful or Theatre) goes on <html data-look> before React renders, so the first frame is already right:
// ?look= in the address, the preview this device remembers, and the look of the battle in the address if seen before.
startLook();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <LookLayer />
  </StrictMode>,
);
